import { useMemo } from 'react';
import { validationCopy } from '../copy/validationCopy';
import type { ValidationWorkspaceState } from './useValidationWorkspace';

export function useValidationActiveFilters(workspace: ValidationWorkspaceState): string[] {
  return useMemo(() => {
    const labels: string[] = [];

    if (workspace.showPassedOnly) {
      labels.push(validationCopy.rail.passed.passedChecks);
    } else {
      if (workspace.severityFilter !== 'all') {
        labels.push(
          workspace.severityFilter === 'critical'
            ? validationCopy.rail.quickFilters.critical
            : workspace.severityFilter === 'error'
              ? validationCopy.rail.quickFilters.errors
              : workspace.severityFilter === 'warning'
                ? validationCopy.rail.quickFilters.warnings
                : workspace.severityFilter
        );
      }

      if (workspace.categoryFilter !== 'all') {
        labels.push(
          workspace.categoryFilter === 'mapping'
            ? validationCopy.rail.repairArea.mapping
            : workspace.categoryFilter === 'required-export'
              ? validationCopy.rail.repairArea.exportData
              : workspace.categoryFilter === 'connectors'
                ? validationCopy.rail.repairArea.connectors
                : workspace.categoryFilter === 'properties'
                  ? validationCopy.rail.repairArea.properties
                  : workspace.categoryFilter === 'components'
                    ? validationCopy.rail.repairArea.components
                    : String(workspace.categoryFilter).charAt(0).toUpperCase() + String(workspace.categoryFilter).slice(1)
        );
      }
    }

    return labels;
  }, [workspace.categoryFilter, workspace.severityFilter, workspace.showPassedOnly]);
}
